export function parseDate(rawDate) {
    const monthNumber = rawDate.substring(5, 7);
    let monthString = '';
    switch (monthNumber) {
        case '01':
            monthString = 'Jan';
            break;
        case '02':
            monthString = 'Feb';
            break;
        case '03':
            monthString = 'Mar';
            break;
        case '04':
            monthString = 'Apr';
            break;
        case '05':
            monthString = 'May';
            break;
        case '06':
            monthString = 'Jun';
            break;
        case '07':
            monthString = 'Jul';
            break;
        case '08':
            monthString = 'Aug';
            break;
        case '09':
            monthString = 'Sep';
            break;
        case '10':
            monthString = 'Oct';
            break;
        case '11':
            monthString = 'Nov';
            break;
        case '12':
            monthString = 'Dec';
            break;
        default:
            monthString = '';
            break;
    }
    const displayDate = `${rawDate.substring(8, 10)} ${monthString} ${parseInt(rawDate.substring(2, 4))}`;
    return displayDate;
}

export function parseYear(rawDate) {
    const yearNum = `${parseInt(rawDate.substring(0, 4))}`;
    return yearNum;
}

export function parseMonth(rawDate) {
    const monthNum = `${parseInt(rawDate.substring(5, 7))}`;
    return monthNum;
}

export function parseDay(rawDate) {
    const dayNum = `${parseInt(rawDate.substring(8, 10))}`;
    return dayNum;
}




// WEBPACK FOOTER //
// ./src/utils/Utils.js